<template>
  <div class="container">
    <div class="vue">
      <!-- 服务资讯 -->
      <div class="business">
        <el-row>
          <el-col class="col " :span="14" :offset="5">
            <div class="business-data width100 flex flexAi-c">
              <div
                :style="{
                  backgroundColor: businessList[index].backgroundColor
                }"
                class="business-list whiteCol pad15 flex flexJc-sb"
                v-for="(item, index) in majorList"
                :key="index"
              >
                <div class="business-head flex flexAi-c">
                  <el-image :src="businessList[index].img"></el-image>
                  <span class="FontW6 padHorizontal10">{{ item.name }}</span>
                </div>
                <div class="business-contant padVertical15">
                  {{ item.text | getText }}
                </div>
                <span
                  @click="businessClick(item)"
                  class="business-more cursorPo"
                >
                  了解更多 →
                </span>
              </div>
            </div>
            <!-- 服务资讯 -->
            <div class="information-data">
              <div class="headline flex flexJc-sb flexAi-c">
                <span class="title FontW8">服务资讯</span>
                <div class="but">
                  <!-- <el-image
                    class="leftBut"
                    @click="leftBut"
                    :src="require('@/assets/image/webImage/left.jpg')"
                  ></el-image>
                  <el-image
                    class="rightBut"
                    @click="rightBut"
                    :src="require('@/assets/image/webImage/right.jpg')"
                  ></el-image> -->
                  <el-button class="FontW6" @click="leftBut">←</el-button>
                  <el-button class="FontW6" @click="rightBut">→</el-button>
                </div>
              </div>
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) in swiperList"
                    :key="index"
                  >
                    <el-image
                      class="flex flexAi-c flexjc-c"
                      :src="item.thumbnail"
                    ></el-image>
                    <div class="swiper-data pad20 ">
                      <div class="FontW8 name fontSize16">{{ item.name }}</div>
                      <div class="title padVertical10">
                        <span>服务资讯 </span>
                        <span>{{ item.createTime | FilterDataTime }}</span>
                      </div>
                      <span class="spanCol note">{{
                        item.text | getText
                      }}</span>
                      <div
                        @click="informationClick(item)"
                        class="cursorPo more primaryCol FontW6"
                      >
                        阅读更多 →
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 我们的客户端 -->
      <div class="client">
        <el-row>
          <el-col class="col " :span="14" :offset="5">
            <div class="header textA-C">
              <div class="title FontW6 padVertical10">我们的客户端</div>
              <div class="padVertical15  introduce spanCol">
                APP For Andriod & IOS 下载
              </div>
            </div>
            <div class="contant flex flexAi-c">
              <el-image
                :src="require('@/assets/image/webImage/phone.png')"
              ></el-image>
              <div class="download flex">
                <!-- appstore -->
                <div class="download-left ">
                  <div class="title fontSize16 padVertical10">
                    <span>客户端</span>
                    <span class="redCol padHorizontal10">APP Store</span>
                    <span>下载</span>
                  </div>
                  <div class="data flex ">
                    <el-button type="primary" @click="download"
                      >直接下载</el-button
                    >
                    <div class="contant padHorizontal10">
                      <div>版本信息：Lingyoutuo_App 1.0</div>
                      <div>软件语言：简体中文</div>
                      <div>发布日期：</div>
                      <div>运行环境：iPhone 各机型</div>
                      <div>需要 IOS 6.0或更高</div>
                    </div>
                  </div>
                  <div class="data flex padVertical20">
                    <el-button type="primary" @click="download"
                      >直接下载</el-button
                    >
                    <div class="contant padHorizontal10">
                      <el-image
                        :src="require('@/assets/image/public/lytewm.png')"
                      ></el-image>
                    </div>
                  </div>
                </div>
                <!-- andriod -->
                <div class="download-right">
                  <div class="title fontSize16 padVertical10">
                    <span>客户端</span>
                    <span class="redCol padHorizontal10">For Andriod</span>
                    <span>下载</span>
                  </div>
                  <div class="data flex ">
                    <el-button type="primary" @click="download"
                      >直接下载</el-button
                    >
                    <div class="contant padHorizontal10">
                      <div>版本信息：Lingyoutuo_App 1.0</div>
                      <div>软件语言：简体中文</div>
                      <div>发布日期：</div>
                      <div>
                        运行环境：支持运行Andriod2.3平台以上的手机安装使用
                      </div>
                      <!-- <div>安装使用</div> -->
                    </div>
                  </div>
                  <div class="data flex padVertical20">
                    <el-button type="primary" @click="download"
                      >直接下载</el-button
                    >
                    <div class="contant padHorizontal10">
                      <el-image
                        :src="require('@/assets/image/public/lytewm.png')"
                      ></el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 我们的服务 -->
      <div class="service">
        <el-row>
          <el-col class="col " :span="14" :offset="5">
            <div class="header textA-C">
              <div class="title FontW6 ">我们的服务</div>
              <div class="padVertical20  introduce spanCol">
                我们关注的不仅仅是个别老人的健康，是我们整个社会的养老。
              </div>
            </div>
            <div
              class="contant flex flexJc-sb                                                                        "
            >
              <div
                class="service-list padVertical10  flex flexAi-c"
                v-for="(item, index) in serviceList"
                :key="index"
              >
                <el-image :src="item.img"></el-image>
                <span class="title padVertical10 FontW6">{{ item.name }}</span>
                <span class="spanCol">{{ item.note }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { apiPageHome } from '@/api/webViews'
import Swiper from 'swiper'
let mySwiper
export default {
  name: '',
  props: [''],
  data() {
    return {
      homeCare: '',
      institutionalPension: '',
      nursingHome: '',
      smartPension: '',
      // 下载跳转
      locationUrl:
        'https://a.app.qq.com/o/simple.jsp?pkgname=com.lingyoutuo.app&fromcase=40002',
      businessList: [
        {
          img: require('@/assets/image/webImage/jjyl.png'),
          title: '居家养老',
          backgroundColor: '#e05355',
          contant:
            '以家庭为核心、以社区为依托、以专业化服务为依靠，为居住在家的老年人提供以解决日常生活困难为主要内容的社会化服务。'
        },
        {
          img: require('@/assets/image/webImage/sqyl.png'),
          title: '社区养老',
          backgroundColor: '#f7b84d',

          contant:
            '举办养老、敬老、托老福利机构;设立老人购物中心和服务中心:开设老人餐桌和老人食堂:建立老年医疗保健机构;建立老年活动中心:设立老年婚介..'
        },
        {
          img: require('@/assets/image/webImage/zhyl.png'),
          title: '智慧养老',
          backgroundColor: '#4a8bda',

          contant:
            '老人如出现紧急情况时，能通过“键式”呼叫发出呼救信息，老人监护人能及时与老人进行联系。同时老人也可直接呼叫服务平台...'
        },
        {
          img: require('@/assets/image/webImage/jgyl.png'),
          title: '机构养老',
          backgroundColor: '#1fbe9e',
          contant:
            '把专业的医疗技术检查和先进设备与康复训练、日常学习、日常饮食、生活养老等专业相融合。以医疗为保障，以康复为支撑，边医边养、综合治疗。'
        }
      ],
      majorList: [],
      swiperList: [],
      swiperList1: [
        {
          img: require('@/assets/image/webImage/lt.png'),
          name: '无锡零忧托居家养老服务有限公司',
          title: '服务资讯',
          note:
            '无锡零忧托居家养老服务有限公司是一家提供精心精细精准的居家医疗护理服务公司，是无锡市长期护理保险定点服务机构。公司自主研发了“零忧托APP”平台'
        },
        {
          img: require('@/assets/image/webImage/lt.png'),
          name: '无锡零忧托居家养老服务有限公司',
          title: '服务资讯',
          note:
            '无锡零忧托居家养老服务有限公司是一家提供精心精细精准的居家医疗护理服务公司，是无锡市长期护理保险定点服务机构。公司自主研发了“零忧托APP”平台'
        },
        {
          img: require('@/assets/image/webImage/lt.png'),
          name: '无锡零忧托居家养老服务有限公司',
          title: '服务资讯',
          note:
            '无锡零忧托居家养老服务有限公司是一家提供精心精细精准的居家医疗护理服务公司，是无锡市长期护理保险定点服务机构。公司自主研发了“零忧托APP”平台'
        },
        {
          img: require('@/assets/image/webImage/lt.png'),
          name: '无锡零忧托居家养老服务有限公司',
          title: '服务资讯',
          note:
            '无锡零忧托居家养老服务有限公司是一家提供精心精细精准的居家医疗护理服务公司，是无锡市长期护理保险定点服务机构。公司自主研发了“零忧托APP”平台'
        }
      ],
      serviceList: [
        {
          name: '健康监控',
          note:
            '建立连续详实的健康档案，通过数据跟踪比对，结合自身健康状况提出合理的保健建议，切实预防疾病隐患。',
          img: require('@/assets/image/webImage/service/jkjc.png')
        },
        {
          name: '医护定制',
          note:
            '根据客户的身体状况需求及家庭条件制定个性化服务；对不方便或不愿意去医院就诊的，提供专业的医护人员上门进行服务。',
          img: require('@/assets/image/webImage/service/yhdz.png')
        },
        {
          name: '照料护理',
          note:
            '根据个人的身体状况和家庭需求，帮助提供相应的照料服务，让用户得到悉心照料。',
          img: require('@/assets/image/webImage/service/zlhl.png')
        },
        {
          name: '心理关爱',
          note:
            '根据用户的心理健康和实际需求，开展多种形式的心理疏导，帮助用户缓解心理压力、放下思想包袱。',
          img: require('@/assets/image/webImage/service/xlga.png')
        },
        {
          name: '康复理疗',
          note:
            '引进康复的专业医护人员，借助康复设备，给予康复措施和护理服务;提供中医推拿、经络按摩、拔罐、刮痧、灸疗等服务。',
          img: require('@/assets/image/webImage/service/kfll.png')
        },
        {
          name: '陪同就医',
          note:
            '可以通过App或者电话进行预约服务。1.预约挂号，缩短等待时间；2.疾病分诊咨询，初步选择就诊科室；3.陪同就医；4.专车接送。',
          img: require('@/assets/image/webImage/service/ptjy.png')
        },
        {
          name: '家政服务',
          note:
            '根据用户家政的需求，提供擦拭门框窗框、物品分类归位、家具除尘、沙发地毯除尘、墙体地面除尘除垢、家用电器表面清洁、厨卫台表面擦拭的清洁。',
          img: require('@/assets/image/webImage/service/jzfw.png')
        },
        {
          name: '就餐助餐',
          note:
            '聘用营养师，进行合理的配餐，给老人提供最健康的饭菜（三公里内可进行配送）。',
          img: require('@/assets/image/webImage/service/jczc.png')
        }
      ]
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.PageHome()
  },

  methods: {
    // 客户端-下载
    download() {
      window.open(this.locationUrl, '_blank')
    },
    // 加载轮播图-服务资讯
    Swiper() {
      mySwiper = new Swiper('.swiper-container', {
        initialSlide: 0,
        pagination: '.swiper-pagination',
        slidesPerView: 3, // 页面分组显示，这里显示为3组
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true // 修改swiper的父元素时，自动初始化swiper
      })
    },
    // 轮播图向左
    leftBut() {
      mySwiper.slidePrev()
    },
    // 轮播图向右
    rightBut() {
      mySwiper.slideNext()
    },
    // 应用
    businessClick(row) {
      console.log(row)
      this.$router.push({
        path: '/articleDtl',
        query: {
          id: row.id
        }
      })
    },
    // 资讯-阅读更多
    informationClick(row) {
      console.log(row)
      this.$router.push({
        path: '/articleDtl',
        query: {
          id: row.id
        }
      })
    },
    /* 接口 */
    // 首页
    PageHome() {
      apiPageHome().then(res => {
        if (res.status === '0') {
          this.majorList[0] = res.data.homeCare
          this.majorList[1] = res.data.institutionalPension
          this.majorList[2] = res.data.nursingHome
          this.majorList[3] = res.data.smartPension
          this.swiperList = res.data.serviceInformation
          setTimeout(() => {
            this.Swiper()
          }, 500)
        }
        console.log(this.majorList)
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  box-sizing: border-box;
  background-color: #f2f2f2;
  .business {
    position: relative;
    top: 0;
    margin-top: -90px;
    .business-data {
      .business-list {
        width: 25%;
        height: 190px;
        flex-direction: column;
        .business-head {
          .el-image {
            width: 30px;
            height: 30px;
          }
        }
        .business-contant {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          overflow: hidden;

          // color: #9e9e9e;
        }
        .business-more:hover {
          color: #319f8f;
        }
      }
    }
    .information-data {
      .headline {
        padding: 40px 0;
        .title {
          font-size: 26px;
        }
        .but {
        }
      }
      .swiper-container {
        padding-bottom: 50px;
        .swiper-wrapper {
          .swiper-slide {
            width: 34%;
            background-color: #fff;
            border-right: 1px solid #f3f3f3;
            .el-image {
              // width: 100px;
              // height: 100px;
              /deep/ img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
              }
            }
            .swiper-data {
              .name {
                padding-bottom: 10px;
              }
              .note {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                color: #8a8687;
              }
              .title {
                color: #ff6b26;
              }
              .more {
                padding-top: 20px;
              }
              .more:hover {
                color: #267b6e;
              }
            }
          }
        }
        .swiper-pagination {
          bottom: 15px;
        }
        /deep/ .swiper-pagination-bullet {
          border-radius: 0;
        }
        /deep/ .swiper-pagination-bullet-active {
          background: #319f8f !important;
        }
      }
    }
  }
  .client {
    background-color: #fff;
    padding: 50px 0;
    .header {
      .title {
        font-size: 36px;
      }
    }
    .contant {
      .download {
        padding-left: 4%;
        .download-left,
        .download-right {
          width: 50%;

          .data {
            .contant {
              /deep/ img {
                width: 85px;
                height: 85px;
              }
            }
          }
        }
      }
    }
  }
  .service {
    background-color: #f2f2f2;
    padding: 50px 0;
    .header {
      .title {
        font-size: 36px;
        padding-bottom: 5px;
      }
    }
    .contant {
      flex-wrap: wrap;
      // flex-grow: initial;
      .service-list {
        width: 22%;
        padding: 20px 0;
        flex-direction: column;
        /deep/ img {
          width: 70px;
          height: 70px;
        }
        .title {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
